import { render, staticRenderFns } from "./createRelevance.vue?vue&type=template&id=99b82c54&scoped=true&"
import script from "./createRelevance.vue?vue&type=script&lang=js&"
export * from "./createRelevance.vue?vue&type=script&lang=js&"
import style0 from "./createRelevance.vue?vue&type=style&index=0&id=99b82c54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b82c54",
  null
  
)

export default component.exports